// extracted by mini-css-extract-plugin
export default {"category":"Brands_category__eZq2m","header":"Brands_header__OW3qr","title":"Brands_title__JDjp5"};